import {createStore, withProps} from '@ngneat/elf';
import {withEntities, withUIEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';
import {GridSortItem} from '@mui/x-data-grid-pro';

import {ClientsService, ClientsServicesFilters, ClientsServiceUI} from '@store/clients/services/clients-services.model';
import {TablePagination} from '@store/common/pagination.model';
import {TableConfig} from '@constants/table.constants';

export interface ClientsServicesState {
  filters: ClientsServicesFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
}

export const clientsServicesStore = createStore(
  {name: 'clients-services'},
  withProps<ClientsServicesState>({
    filters: {
      search: '',
      tableFilters: ClientsServicesFilters.initTableFilters(),
      excludeTableFilters: ClientsServicesFilters.initExcludeTableFilters(),
      filterExpiredContracts: true,
      filterExpiredServices: true
    },
    sort: {
      field: 'service.clientWasteName',
      sort: 'asc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
  }),
  withEntities<ClientsService>(),
  withUIEntities<ClientsServiceUI>(),
  withPagination(),
  withRequestsStatus(),
);
